<div class="balls" *ngIf="loading">
  <div></div>
  <div></div>
  <div></div>
</div>
